/* global axios */
import ApiClient from './ApiClient';

class SummaryReportsAPI extends ApiClient {
  constructor() {
    super('summary_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getAgentReports({ since, until, businessHours, comunicanteCampaign } = {}) {
    return axios.get(`${this.url}/agent`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        comunicante_campaign: comunicanteCampaign,
      },
    });
  }
}

export default new SummaryReportsAPI();
